<template>
  <h-item
    :item="item"
    :count="count"
    :dense="dense"
    icon="kit"
    @click="clicked()"
  />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import HItem from './Item'

  export default {
    components: {
      HItem,
    },

    props: {
      item: {
        required: true,
        type: Object,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      dense: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapGetters('catalog', [
        'linkedItems',
      ]),
      ...mapGetters('orders', [
        'itemCounter',
      ]),
      count () {
        return this.itemCounter(this.item.id)
      },
      hideHeader () {
        return parseFloat(this.item.price).equalTo(0)
            && this.item.config.hide_kit_header === '1' // boolean config values are strings :(
      },
    },

    methods: {
      ...mapActions('orders', [
        'addItems',
      ]),
      clicked () {
        if (this.disabled) {
          return
        }
        const items = this.linkedItems(this.item.id)
        if (! this.hideHeader) {
          items.unshift(this.item)
        }
        this.addItems(items)
      },
    },
  }
</script>
